module.exports = __webpack_public_path__ + "img/user-6.b95ae25a.png";